const POSSIBLE_CHARACTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
const MAX_LENGTH = 5;

const generateRandomId = (): string =>
    [...Array(MAX_LENGTH)]
        .reduce(
            output =>
                output + POSSIBLE_CHARACTERS.charAt(Math.floor(Math.random() * POSSIBLE_CHARACTERS.length))
            ,
            ''
        );

export default generateRandomId;